import { useTheme } from '@mui/material/styles';
import { useRoutes } from 'react-router-dom';
import BrandBillingGuard from './components/brand-billing-guard/brand-billing-guard';

const MainPage = ({ isDesktop = true, pathname, routes, isShowOfferBanner = false }) => {
  const element = useRoutes(routes);
  const theme = useTheme();
  let currentRoute = routes.find(route => route.path === pathname?.replace("/", ""));
  let isChildRoute = false;
  if (currentRoute) {
    isChildRoute = currentRoute.element?.props?.permissions ? true : false;
  }
  return (
    <div
      style={{
        ...(isChildRoute
          ? {
            flexGrow: 1,
            minHeight: '100%',
            padding: isDesktop && theme.spacing(2),
            position: 'relative',
            top: '64px',
            width: isDesktop ? 'calc(100vw - 352px)' : '100%',
            height: !isDesktop ? 'calc(100vh - 133px)' : '100%',
            overflow: 'auto',
            ...(pathname === '/competitors' && isDesktop ? {
              minHeight: 0,
              height: `calc(100dvh - ${64 + (isShowOfferBanner ? 50 : 0)}px)`,
              boxSizing: 'border-box',
              paddingBottom: theme.spacing(4),
            } : {}),
          }
          : {})
      }}
    >
      <BrandBillingGuard>{element}</BrandBillingGuard>
    </div>
  );
};

export default MainPage;
